import { deleteAccount } from "../../services/settingsService";
import { createSignal } from "solid-js";
import { useNavigate } from "@solidjs/router";
import Loading from "../Loading";
import { clearUserStore } from "../../stores/userStore";

export default function DeleteAccount({ email, exit }) {
  const [loading, setLoading] = createSignal(false);
  const nav = useNavigate();

  async function deleteAcc() {
    setLoading(true);
    await deleteAccount(email);
    clearUserStore();
    setTimeout(() => {
      setLoading(false);
      nav("/", { replace: true });
    }, 500);
  }

  return (
    <div>
      <h2>Are you sure you want to delete your account?</h2>
      <p>This action cannot be undone.</p>
      <div class="row">
        <button onClick={() => exit(false)}>Cancel</button>
        <button onClick={() => deleteAcc()}>Delete Account</button>
      </div>
      <Loading show={loading()} />
    </div>
  );
}
